import * as React from 'react';
import * as styles from './styles.css';

import { ArticleHeading1, ArticleHeading2, ArticleParagraph1, Button } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';

import { NBSP } from '../../constants/symbols';
import { SEND_REPORT_BLOCK_ID } from '../../constants/report';

export interface ISendReportProps {
  isDesktop: boolean;
  onSubmit(): void;
  ref?: React.Ref<HTMLDivElement>;
}

export function SendReport({ isDesktop, onSubmit, ref }: ISendReportProps): React.JSX.Element {
  return (
    <div ref={ref} id={SEND_REPORT_BLOCK_ID} className={styles['container']}>
      <div className={styles['title']}>
        <ConditionalWrapper if={isDesktop} ThenComponent={ArticleHeading1} ElseComponent={ArticleHeading2}>
          <>Отправьте отчёт от{NBSP}своего имени</>
        </ConditionalWrapper>
      </div>
      <div className={styles['text']}>
        <ArticleParagraph1 color="text-inverted-default">
          Уточните параметры квартиры и список аналогов
        </ArticleParagraph1>
      </div>
      <div className={styles['buttons']}>
        <Button theme="fill_white_primary" size="M" fullWidth={!isDesktop} onClick={onSubmit}>
          Далее
        </Button>
      </div>
    </div>
  );
}
